export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7970.5eccad6f.jpg";